// extracted by mini-css-extract-plugin
export var infoItem = "_ps-2";
export var title = "_ps-0";
export var value = "_ps-1";